/* ==========================================================================
   Ölçü bulucu — bkz. sections/pdp-size-finder.liquid.
   colorfullworlds.com sürümünden uyarlandı. Birim yalnızca cm.

   Bir ölçü, duvar `data-rec` genişliğine ulaşınca önerilir. En küçüğün
   altında yine en küçük gösterilir, farklı bir cümleyle.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__sizeFinderBound) return;
  window.__sizeFinderBound = true;

  var ACTIVE = 'is-active';

  function format(cm) {
    return Math.round(cm) + ' cm';
  }

  function normalize(value) {
    return String(value == null ? '' : value).toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function Finder(el) {
    this.el = el;
    this.range = el.querySelector('[data-size-finder-range]');
    this.bubble = el.querySelector('[data-size-finder-bubble]');
    this.result = el.querySelector('[data-size-finder-result]');
    this.choose = el.querySelector('[data-size-finder-choose]');
    this.visuals = Array.prototype.slice.call(el.querySelectorAll('[data-size-finder-visual]'));
    this.buttons = Array.prototype.slice.call(el.querySelectorAll('[data-size-finder-size]'));
    this.colours = Array.prototype.slice.call(el.querySelectorAll('[data-size-finder-colour]'));
    this.colourName = el.querySelector('[data-size-finder-colour-name]');
    this.looks = readLooks(el);
    this.min = Number(el.dataset.min) || 0;
    this.max = Number(el.dataset.max) || 100;

    this.sizes = this.buttons.map(function (button) {
      return {
        index: button.dataset.sizeFinderSize,
        rec: Number(button.dataset.rec) || 0,
        optionValue: button.dataset.optionValue || '',
        button: button
      };
    }).sort(function (a, b) { return a.rec - b.rec; });

    if (!this.range || !this.sizes.length) return;

    this.range.addEventListener('input', this.setValue.bind(this, null));
    this.buttons.forEach(function (button) {
      button.addEventListener('click', this.pick.bind(this, button.dataset.sizeFinderSize));
    }, this);
    if (this.choose) this.choose.addEventListener('click', this.selectVariant.bind(this));
    this.colours.forEach(function (button) {
      button.addEventListener('click', this.pickColour.bind(this, Number(button.dataset.sizeFinderColour)));
    }, this);

    if ('ResizeObserver' in window) {
      new ResizeObserver(this.placeBubble.bind(this)).observe(this.range);
    } else {
      window.addEventListener('resize', this.placeBubble.bind(this));
    }

    el.classList.add('is-enhanced');

    // Start on the size already chosen in the buy box, if it matches one.
    var current = this.sizeOfVariant();
    this.setValue(current ? current.rec : this.sizes[0].rec);
    this.syncColour();

    this.watchVariant();
  }

  // The colour row's PNGs (snippets/size-guide-looks, variant mode):
  // {"opt": colour option index, "looks": [{"v": value, "s": 600px, "l": 1200px}]}.
  function readLooks(el) {
    var script = el.querySelector('script[data-size-finder-looks]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  Finder.prototype.sizeFor = function (cm) {
    var match = this.sizes[0];
    this.sizes.forEach(function (size) {
      if (cm >= size.rec) match = size;
    });
    return match;
  };

  Finder.prototype.setValue = function (cm) {
    var value = cm == null ? Number(this.range.value) : cm;
    value = Math.min(Math.max(Math.round(value), this.min), this.max);

    if (Number(this.range.value) !== value) this.range.value = String(value);
    this.value = value;
    this.render();
  };

  Finder.prototype.pick = function (index) {
    for (var i = 0; i < this.sizes.length; i++) {
      if (this.sizes[i].index === index) {
        this.setValue(this.sizes[i].rec);
        return;
      }
    }
  };

  Finder.prototype.render = function () {
    var ratio = this.max === this.min ? 0 : (this.value - this.min) / (this.max - this.min);
    this.range.style.setProperty('--sf-progress', (ratio * 100).toFixed(2) + '%');
    this.range.setAttribute('aria-valuetext', format(this.value));
    if (this.bubble) this.bubble.textContent = format(this.value);
    this.placeBubble();

    var size = this.sizeFor(this.value);
    this.active = size;

    this.buttons.forEach(function (button) {
      var on = button.dataset.sizeFinderSize === size.index;
      button.setAttribute('aria-pressed', String(on));
      button.classList.toggle(ACTIVE, on);
    });

    this.visuals.forEach(function (visual) {
      visual.classList.toggle(ACTIVE, visual.dataset.sizeFinderVisual === size.index);
    });

    if (this.result) {
      var tooSmall = this.value < size.rec;
      var template = (tooSmall ? this.el.dataset.smallTemplate : this.el.dataset.resultTemplate) || '';
      this.result.textContent = template.replace('[width]', format(size.rec));
    }

    if (this.choose) this.choose.hidden = !this.inputFor(size);
  };

  // Keeps the bubble centred over the thumb. The thumb travels the track minus
  // its own width, so a plain percentage would drift at both ends.
  Finder.prototype.placeBubble = function () {
    if (!this.bubble) return;
    var width = this.range.offsetWidth;
    if (!width) return;
    var thumb = parseFloat(getComputedStyle(this.el).getPropertyValue('--sf-thumb')) || 22;
    var ratio = this.max === this.min ? 0 : (this.value - this.min) / (this.max - this.min);
    this.bubble.style.left = (thumb / 2 + ratio * (width - thumb)).toFixed(1) + 'px';
  };

  /* --- buy box ----------------------------------------------------------- */

  // Recommendations, recently-viewed and quick-shop render variant inputs too,
  // so every lookup is scoped to this product's form (same as size-guide.js).
  Finder.prototype.inputs = function (option) {
    if (option == null) option = this.el.dataset.optionIndex;
    var id = this.el.dataset.productId;
    if (!option || String(option) === '0') return [];
    return Array.prototype.slice.call(document.querySelectorAll(
      'input[data-variant-input][data-index="option' + option + '"]' + (id ? '[form$="-' + id + '"]' : '')
    ));
  };

  Finder.prototype.colourInputs = function () {
    return this.looks ? this.inputs(this.looks.opt + 1) : [];
  };

  Finder.prototype.inputFor = function (size) {
    var inputs = this.inputs();
    var target = normalize(size.optionValue);
    for (var i = 0; i < inputs.length; i++) {
      if (normalize(inputs[i].value) === target) return inputs[i];
    }
    return null;
  };

  Finder.prototype.sizeOfVariant = function () {
    var checked = this.inputs().filter(function (input) { return input.checked; })[0];
    if (!checked) return null;
    var value = normalize(checked.value);
    for (var i = 0; i < this.sizes.length; i++) {
      if (normalize(this.sizes[i].optionValue) === value) return this.sizes[i];
    }
    return null;
  };

  Finder.prototype.selectVariant = function () {
    var input = this.active && this.inputFor(this.active);
    if (!input) return;

    if (!input.checked) input.click();

    var wrap = input.closest('.variant-wrapper') || input;
    wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  // A swatch picks its colour in the buy box, as a click there would (price,
  // stock and URL follow as usual); the change then redraws the room here.
  Finder.prototype.pickColour = function (index) {
    var look = this.looks && this.looks.looks[index];
    if (!look) return;
    var value = normalize(look.v);
    var input = this.colourInputs().filter(function (i) { return normalize(i.value) === value; })[0];
    if (input && !input.checked) input.click();
  };

  // The room shows the buy box's colour, picked there or here.
  Finder.prototype.syncColour = function () {
    if (!this.looks) return;
    var checked = this.colourInputs().filter(function (input) { return input.checked; })[0];
    if (!checked) return;
    var value = normalize(checked.value);
    var looks = this.looks.looks;
    for (var i = 0; i < looks.length; i++) {
      if (normalize(looks[i].v) === value) {
        this.showColour(i);
        return;
      }
    }
  };

  Finder.prototype.showColour = function (index) {
    var look = this.looks.looks[index];
    this.colours.forEach(function (button) {
      button.setAttribute('aria-pressed', String(Number(button.dataset.sizeFinderColour) === index));
    });
    if (this.colourName) this.colourName.textContent = look.v;
    this.el.querySelectorAll('img[data-sg-png]').forEach(function (img) {
      img.srcset = look.s + ' 600w, ' + look.l + ' 1200w';
      img.src = look.s;
    });
  };

  // A size picked in the buy box moves the slider here too; a colour there
  // redraws the room.
  Finder.prototype.watchVariant = function () {
    var self = this;
    this.inputs().forEach(function (input) {
      input.addEventListener('change', function () {
        var size = self.sizeOfVariant();
        if (size && size !== self.active) self.setValue(size.rec);
      });
    });
    this.colourInputs().forEach(function (input) {
      input.addEventListener('change', this.syncColour.bind(this));
    }, this);
  };

  /* --- wiring ------------------------------------------------------------ */

  var finders = [];

  function init() {
    document.querySelectorAll('[data-size-finder]').forEach(function (el) {
      if (el.dataset.sizeFinderReady) return;
      el.dataset.sizeFinderReady = 'true';
      finders.push(new Finder(el));
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
